var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('BasePageContainer',{staticClass:"pt-6"},[_c('page-header',{attrs:{"has-back":""}},[_vm._v(" "+_vm._s(_vm.hasCopyEvent ? '予定のコピー' : '予定作成')+" ")]),_c('event-form',{ref:"form",attrs:{"event":_vm.event,"is-copy":_vm.hasCopyEvent},on:{"submit":_vm.createEvent}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }